module.exports = __webpack_public_path__ + "static/media/netcore.08a16192.png";